export function initBurgerMenu() {
    const header = document.querySelector('.winefestival-header');
    const burger = header ? header.querySelector('.burger-btn') : null;
    if (!burger) {
        return false;
    }
    
    burger.addEventListener('click', (evt) => {
        const mobileWrapper = header ? header.querySelector('.nav-wrapper') : null;
        if (mobileWrapper) {
            mobileWrapper.classList.toggle('active');
        }

        const isActive = burger.classList.toggle("active");
        burger.classList.toggle("not-active", !isActive);
        burger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
    });

    return true;
}
